import VuetableFieldLink from "../fields/vuetable-field-company.vue";

export default {
    getFields(resource) {
        return fields[resource] ? fields[resource] : [];
    }
}


const fields = {
    "envelopes": [
        {
            name: VuetableFieldLink,
            field: "subject",
            custom: {
                label: (data) => {
                    const states = {
                        created: "<i class='fa fa-clock-o mr-2'></i>",
                        sent: "<i class='fa fa-clock-o mr-2'></i>",
                        expiring: "Expiring Soon",
                        completed: "<i class='fa fa-check text-success mr-2'></i>"
                    }
                    return `
                    <div>
                        <p> ${states[data.status] || states.created } <b>${data.subject || ""}</b> </p>
                    
                        <p>
                            To: ${data.recipients ? JSON.parse(data.recipients).map((person) => JSON.parse(person).name).join(", ") : ""}
                        </p>
                    </div>
                    `
                }
            }
        },
        {
            name: "status",
            formatter(value) {
                const states = {
                    created: "Waiting for Others",
                    sent: "Waiting for Others",
                    expiring: "Expiring Soon",
                    completed: "Completed"
                }
                return states[value] || states.created
            }
        }
    ]
}
